import { Card, LuIcon, Spinner } from "@overmap-ai/blocks"
import { ImageFile } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { modelIconMapping } from "../../mappings/icons"

interface ImageFileThumbnailProps extends Omit<ComponentProps<typeof Card>, "children"> {
	file: File | null
	errored: boolean
}

export const ImageFileThumbnail = memo((props: ImageFileThumbnailProps) => {
	const { ref, className, file, errored, ...rest } = props

	const renderContent = () => {
		if (errored) {
			return (
				<div className="flex size-full items-center justify-center">
					<LuIcon icon={modelIconMapping.alertCircle} color="var(--base-a11)" />
				</div>
			)
		}

		if (!file) {
			return (
				<div className="flex size-full items-center justify-center">
					<Spinner size="xs" accentColor="base" />
				</div>
			)
		}

		return <ImageFile className="block size-full max-w-full object-cover" file={file} />
	}

	return (
		<Card ref={ref} className={cx("p-0! size-12 shrink-0 grow-0 overflow-hidden", className)} {...rest}>
			{renderContent()}
		</Card>
	)
})
ImageFileThumbnail.displayName = "ImageFileThumbnail"
